import { render, staticRenderFns } from "./PatrimonioDetalheCampos.vue?vue&type=template&id=5c276d25&scoped=true&"
import script from "./PatrimonioDetalheCampos.vue?vue&type=script&lang=js&"
export * from "./PatrimonioDetalheCampos.vue?vue&type=script&lang=js&"
import style0 from "./PatrimonioDetalheCampos.vue?vue&type=style&index=0&id=5c276d25&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c276d25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
